import { ClientCertification } from "./clientsCertifications.dto";
import { ClientDto } from "./clients.dto";
import { AdditionalServiceDto } from "@dtos/additional-services.dto";
import { TransportPrincipalType } from "@enums/client.enum";
import { TransportStatus } from "@enums/transport.enum";

export class ClientAdditionalServiceDto extends AdditionalServiceDto {
    override certification: ClientCertification | null = null;
    client: number | null = null;
    override is_common: boolean = false;
    template_id: number | null = null;
    transport_principal_types: TransportPrincipalType[] = [];
    legs: number[] = [];

    /**
     * Genera un objeto para actualización (PUT/PATCH) sin IDs anidados
     */
    toUpdate(): any {
        const update: any = {
            client: this.client,
            name: this.name,
            description: this.description,
            default_selected: this.default_selected,
            client_price: this.client_price,
            driver_payment: this.driver_payment,
            state: true,
            visible_by_driver: this.visible_by_driver,
            applyment_moment: this.applyment_moment,
            is_appointment_management: this.is_appointment_management,
            transport_principal_types: this.transport_principal_types.length > 0 ? this.transport_principal_types : [TransportPrincipalType.SIMPLE_MOVEMENT],
            requires_certification: this.requires_certification,
            requires_image: this.requires_image,
            requires_location: this.requires_location,
            transport_status: this.transport_status ?? TransportStatus.PENDING
        };

        // Si tiene certificación, adaptarla sin IDs anidados
        if (this.certification) {
            update.certification = {
                client: this.certification.client,
                title: this.certification.title,
                description: this.certification.description,
                max_tries_per_week: this.certification.max_tries_per_week,
                allow_new_drivers: this.certification.allow_new_drivers,
                exam: {
                    title: this.certification.exam.title,
                    max_tries_per_week: this.certification.exam.max_tries_per_week,
                    questions: this.certification.exam.questions.map(q => ({
                        title: q.title,
                        type: q.type,
                        required: q.required,
                        order: q.order,
                        requires_manual_review: q.requires_manual_review,
                        options: q.options.map(opt => ({
                            title: opt.title,
                            is_correct: opt.is_correct
                        }))
                    }))
                }
            };
        }

        return update;
    }
}
